import React from "react";
import editIcon from "../../../../static/images/edit-icon.png";
import { PERMISSIONS } from "../../../../constants/permissions";

export const CharacteristicProgressViewMode = ({ styles, assessmentDetails, assessmentDetailsNew, woundProgressOptions, onEdit, hasPermission, isSignedLocked }) => (
  <>
      <button className={`float-sm-right ${styles.tab_edit}`} onClick={onEdit} disabled={!hasPermission(PERMISSIONS.CHARACTERISTIC_PROGRESS_EDIT) || isSignedLocked }>
        <img src={editIcon} alt="edit" />
        Edit
      </button>
    <p>
      <label>Wound Progress:</label>
      <span>
        {assessmentDetailsNew?.woundStage
          ? woundProgressOptions?.find((data) => data.key === assessmentDetailsNew.woundStage.toLowerCase())?.value
          : "-"}
      </span>
    </p>
  </>
);
